var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolutions = function SvgSolutions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "solutions_svg2__a",
    x1: 35.25,
    x2: 148.18,
    y1: 143.06,
    y2: 36.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#solutions_svg2__a",
    id: "solutions_svg2__b",
    x1: 35.25,
    x2: 148.17,
    y1: 143.06,
    y2: 36.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#solutions_svg2__a",
    id: "solutions_svg2__c",
    x1: 52.58,
    x2: 165.5,
    y1: 161.36,
    y2: 54.38
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#solutions_svg2__a",
    id: "solutions_svg2__d",
    x1: 52.58,
    x2: 165.5,
    y1: 161.36,
    y2: 54.38
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#solutions_svg2__a",
    id: "solutions_svg2__e",
    x1: 10.14,
    x2: 123.06,
    y1: 116.55,
    y2: 9.58
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#solutions_svg2__a",
    id: "solutions_svg2__f",
    x1: 10.14,
    x2: 123.06,
    y1: 116.56,
    y2: 9.58
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#solutions_svg2__a",
    id: "solutions_svg2__g",
    x1: 54.25,
    x2: 167.17,
    y1: 163.11,
    y2: 56.13
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#solutions_svg2__a",
    id: "solutions_svg2__h",
    x1: 89.43,
    x2: 202.35,
    y1: 200.25,
    y2: 93.27
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#solutions_svg2__a",
    id: "solutions_svg2__i",
    x1: 89.43,
    x2: 202.35,
    y1: 200.25,
    y2: 93.27
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M93.18 106.12a2.932 2.932 0 1 0 5.72-1.3c-1.55-6.84-5.42-13.04-10.9-17.48a31.5 31.5 0 0 0-19.74-6.98c-17.33 0-31.43 14.1-31.43 31.43s14.1 31.43 31.43 31.43c14.23 0 26.72-9.6 30.38-23.34a2.928 2.928 0 0 0-5.66-1.5c-2.97 11.18-13.13 18.99-24.71 18.99-14.1 0-25.57-11.47-25.57-25.57s11.47-25.57 25.57-25.57c5.92 0 11.47 1.96 16.06 5.67 4.46 3.61 7.61 8.66 8.87 14.22Z",
    style: {
      fill: "url(#solutions_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.84 111.8c0 8.5 6.91 15.41 15.41 15.41s15.41-6.91 15.41-15.41-6.91-15.41-15.41-15.41-15.41 6.91-15.41 15.41m24.96 0c0 5.27-4.28 9.55-9.55 9.55s-9.55-4.28-9.55-9.55 4.28-9.55 9.55-9.55 9.55 4.28 9.55 9.55",
    style: {
      fill: "url(#solutions_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.12 48.41h-5.74c-.45-1.39-1.01-2.74-1.67-4.04l4.06-4.06c1.9-1.9 1.9-5 0-6.91l-5.45-5.45c-1.9-1.9-5-1.9-6.91 0l-4.06 4.06c-1.3-.66-2.65-1.22-4.04-1.67V24.6c0-2.69-2.19-4.88-4.88-4.88h-7.7c-2.69 0-4.88 2.19-4.88 4.88v5.74c-1.39.45-2.74 1.01-4.04 1.67l-4.06-4.06c-1.9-1.9-5-1.9-6.91 0l-5.45 5.45c-1.9 1.9-1.9 5 0 6.9l4.06 4.06c-.66 1.3-1.22 2.65-1.67 4.04h-5.74c-2.69 0-4.88 2.19-4.88 4.88v7.7c0 2.69 2.19 4.88 4.88 4.88h5.74c.45 1.39 1.01 2.74 1.67 4.04l-4.06 4.06c-1.9 1.9-1.9 5 0 6.91l5.45 5.45c1.9 1.9 5 1.9 6.91 0l4.06-4.06c1.3.66 2.65 1.22 4.04 1.67v5.74c0 2.69 2.19 4.88 4.88 4.88h7.7c2.69 0 4.88-2.19 4.88-4.88v-5.74c1.39-.45 2.74-1.01 4.04-1.67l4.06 4.06c1.9 1.9 5 1.9 6.91 0l5.45-5.45c1.9-1.9 1.9-5 0-6.91l-4.06-4.06c.66-1.3 1.22-2.65 1.67-4.04h5.74c2.69 0 4.88-2.19 4.88-4.88v-7.7c0-2.69-2.19-4.88-4.88-4.88Zm-.98 11.61h-5.49c-2.18 0-4.06 1.41-4.68 3.51-.44 1.46-1.02 2.89-1.75 4.23-1.04 1.93-.71 4.25.83 5.79l3.88 3.88-4.07 4.07-3.88-3.88a4.86 4.86 0 0 0-5.79-.83c-1.34.73-2.76 1.31-4.23 1.75a4.86 4.86 0 0 0-3.51 4.68v5.49h-5.75v-5.49c0-2.18-1.41-4.06-3.51-4.68-1.46-.44-2.89-1.02-4.23-1.75-1.93-1.04-4.26-.71-5.79.83l-3.88 3.88-4.07-4.07 3.88-3.88a4.86 4.86 0 0 0 .83-5.79c-.73-1.34-1.31-2.76-1.75-4.23a4.86 4.86 0 0 0-4.68-3.51h-5.49v-5.75h5.49c2.18 0 4.06-1.41 4.68-3.51.44-1.46 1.02-2.89 1.75-4.23 1.04-1.93.71-4.25-.83-5.79l-3.88-3.88 4.07-4.07 3.88 3.88a4.86 4.86 0 0 0 5.79.83c1.34-.73 2.76-1.31 4.23-1.75a4.86 4.86 0 0 0 3.51-4.68v-5.49h5.75v5.49c0 2.18 1.41 4.06 3.51 4.68 1.46.44 2.89 1.02 4.23 1.75 1.93 1.04 4.26.71 5.79-.83l3.88-3.88 4.07 4.07-3.88 3.88a4.86 4.86 0 0 0-.83 5.79c.73 1.34 1.31 2.76 1.75 4.23a4.86 4.86 0 0 0 4.68 3.51h5.49z",
    style: {
      fill: "url(#solutions_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.58 43.36c-7.6 0-13.79 6.18-13.79 13.79s6.18 13.79 13.79 13.79 13.79-6.18 13.79-13.79-6.18-13.79-13.79-13.79m0 21.71c-4.37 0-7.93-3.56-7.93-7.93s3.56-7.93 7.93-7.93 7.93 3.56 7.93 7.93-3.56 7.93-7.93 7.93",
    style: {
      fill: "url(#solutions_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.62 43.25c8.02 0 15.43-4.68 18.9-11.91a2.932 2.932 0 0 0-5.29-2.53c-2.5 5.21-7.84 8.58-13.61 8.58-8.32 0-15.08-6.77-15.08-15.08s6.76-15.08 15.08-15.08c6.42 0 12.14 4.07 14.25 10.13a2.932 2.932 0 1 0 5.54-1.92 20.94 20.94 0 0 0-19.78-14.07c-11.55 0-20.94 9.39-20.94 20.94s9.39 20.94 20.94 20.94Z",
    style: {
      fill: "url(#solutions_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.62 33.64c1.62 0 2.93-1.31 2.93-2.93v-5.46h5.46c1.62 0 2.93-1.31 2.93-2.93s-1.31-2.93-2.93-2.93h-5.46v-5.46c0-1.62-1.31-2.93-2.93-2.93s-2.93 1.31-2.93 2.93v5.46h-5.46c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93h5.46v5.46c0 1.62 1.31 2.93 2.93 2.93",
    style: {
      fill: "url(#solutions_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.98 126.88 142.82 106a4.89 4.89 0 0 0-4.88 0l-1.44.83v-3.29c0-3.12-2.54-5.66-5.66-5.66h-13.78a50.2 50.2 0 0 0-4.45-10.74l9.74-9.74a5.667 5.667 0 0 0 0-8.01l-11.68-11.68c-1.07-1.07-2.49-1.66-4.01-1.66s-2.94.59-4.01 1.66l-9.74 9.74c-3.39-1.89-7-3.38-10.74-4.45V49.22c0-3.12-2.54-5.66-5.66-5.66H59.99c-3.12 0-5.66 2.54-5.66 5.66V63a50.2 50.2 0 0 0-10.74 4.45l-9.74-9.74c-1.07-1.07-2.49-1.66-4.01-1.66s-2.94.59-4.01 1.66L14.15 69.39a5.667 5.667 0 0 0 0 8.01l9.74 9.74c-1.89 3.39-3.38 7-4.45 10.74H5.66c-3.12 0-5.66 2.54-5.66 5.66v16.52c0 3.12 2.54 5.66 5.66 5.66h13.78c1.06 3.74 2.56 7.35 4.45 10.74l-9.74 9.74a5.667 5.667 0 0 0 0 8.01l11.68 11.68c1.07 1.07 2.49 1.66 4.01 1.66s2.94-.59 4.01-1.66l9.74-9.74c3.39 1.89 7 3.38 10.74 4.45v13.78c0 3.12 2.54 5.66 5.66 5.66h16.52c3.12 0 5.66-2.54 5.66-5.66V160.6c3.74-1.06 7.35-2.56 10.74-4.45l6.41 6.41v10.29c0 1.74.94 3.36 2.44 4.23l36.16 20.88c.75.44 1.6.65 2.44.65s1.69-.22 2.44-.65l36.16-20.88a4.89 4.89 0 0 0 2.44-4.23v-13.49c0-1.62-1.31-2.93-2.93-2.93s-2.93 1.31-2.93 2.93v12.93l-35.19 20.31-35.19-20.31v-40.63l35.19-20.31 35.19 20.31v14.03c0 1.62 1.31 2.93 2.93 2.93s2.93-1.31 2.93-2.93V131.1c0-1.74-.94-3.36-2.44-4.23Zm-48.35-16.66-28.86 16.66a4.89 4.89 0 0 0-2.44 4.23v23.18l-2.38-2.38c-1.78-1.78-4.58-2.16-6.79-.92a44.8 44.8 0 0 1-9.69 4.01c-2.44.69-4.15 2.93-4.15 5.46v13.73H60.19v-13.73c0-2.52-1.71-4.77-4.15-5.46-3.38-.95-6.64-2.3-9.69-4.01-2.22-1.24-5.01-.86-6.79.92l-9.71 9.71-11.4-11.4 9.71-9.71c1.78-1.78 2.16-4.58.92-6.8a44.8 44.8 0 0 1-4.01-9.69c-.69-2.44-2.93-4.15-5.46-4.15H5.86v-16.13h13.73c2.52 0 4.77-1.71 5.46-4.15.95-3.38 2.3-6.64 4.01-9.69 1.24-2.22.86-5.01-.92-6.79l-9.71-9.71L29.83 62l9.71 9.71c1.78 1.78 4.58 2.16 6.79.92 3.06-1.71 6.32-3.06 9.69-4.01 2.44-.69 4.15-2.93 4.15-5.46V49.43H76.3v13.73c0 2.52 1.71 4.77 4.15 5.46 3.38.95 6.64 2.3 9.69 4.01 2.22 1.24 5.01.86 6.79-.92l9.71-9.71 11.4 11.4-9.71 9.71c-1.79 1.78-2.16 4.58-.92 6.8 1.71 3.06 3.06 6.32 4.01 9.69.69 2.44 2.93 4.15 5.46 4.15h13.73v6.48Z",
    style: {
      fill: "url(#solutions_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.1 151.99c0 13.39 10.89 24.28 24.28 24.28s24.28-10.89 24.28-24.28-10.89-24.28-24.28-24.28-24.28 10.89-24.28 24.28m42.69 0c0 10.16-8.26 18.42-18.42 18.42s-18.42-8.26-18.42-18.42 8.26-18.42 18.42-18.42 18.42 8.26 18.42 18.42",
    style: {
      fill: "url(#solutions_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.37 165.72c7.57 0 13.73-6.16 13.73-13.73s-6.16-13.73-13.73-13.73-13.73 6.16-13.73 13.73 6.16 13.73 13.73 13.73m0-21.6c4.34 0 7.87 3.53 7.87 7.87s-3.53 7.87-7.87 7.87-7.87-3.53-7.87-7.87 3.53-7.87 7.87-7.87",
    style: {
      fill: "url(#solutions_svg2__i)"
    }
  }));
};
export default SvgSolutions;